import { isObject } from 'utils/tool.js'

/**
 * 咨询师主页中的心乐土相关逻辑
 */
export default {
  computed: {
    // 心乐土工作室
    mixinStudio() {
      const { studio } = this.$store.state.homepage.basicInfo || {}
      return isObject(studio) ? studio : null
    },
    mixinShowStudioInfo() {
      const { isXltMp } = this.$route.query
      return this.mixinStudio && +isXltMp === 1
    }
  }
}
